// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError, AxiosResponse } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { getWorkshopData } from '../../../apis/workshop';
import { WorkshopInformation } from '../../../types/Model';
import getWorkshopDataActions from '../../actionCreators/workshop/getWorkshopDataActions';
import { RootAction } from '../../rootActionCreator';
import { RootState } from '../../rootReducer';

const outputActions = {
  success: getWorkshopDataActions.success,
  failure: getWorkshopDataActions.failure
};

type RequestActionTypes = ActionType<typeof getWorkshopDataActions.request>;
type OutputActionTypes = ActionType<typeof outputActions>;

const getWorkshopDataEpic = (
  action$: Observable<RootAction>,
  _state$?: Observable<RootState>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      // action filter
      getType(getWorkshopDataActions.request)
    ),
    switchMap((action: RequestActionTypes) => {
      // prepare api params
      const id = action.payload.id || 0;
      // send api promise
      return getWorkshopData(id)
        .then((response: AxiosResponse<WorkshopInformation>) => {
          // handle success case here
          return getWorkshopDataActions.success({
            workshopData: response.data
          });
        })
        .catch((error: AxiosError) => {
          // handle error case here
          return getWorkshopDataActions.failure({ error });
        });
    })
  );
};

export { getWorkshopDataEpic as default};
